export function handelLabel(key, genaralCustom) {
  let a = genaralCustom?.find((item) => item.value === key);
  console.log("Label==", a?.label);
  return a?.label;
}
